import { ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessengerService } from '../../messenger/messenger.service';
import { BreadcrumbsService } from '../../shared/components/breadcrumbs/breadcrumbs.service';
import { Auth } from '../auth.service';
var RegistrationComponent = /** @class */ (function () {
    function RegistrationComponent(_auth, _router, _route, _messenger, _breadcrumbs) {
        this._auth = _auth;
        this._router = _router;
        this._route = _route;
        this._messenger = _messenger;
        this._breadcrumbs = _breadcrumbs;
        this.pending = false;
        this.submitted = false;
        this.msgs = [];
    }
    Object.defineProperty(RegistrationComponent.prototype, "next", {
        get: function () {
            var next = this._route.snapshot.queryParams['n'];
            return next && decodeURIComponent(next) || '/kezdolap';
        },
        enumerable: true,
        configurable: true
    });
    RegistrationComponent.prototype.ngOnInit = function () {
        this.user = {
            email: '',
            password: '',
            password_confirmation: '',
            lastname: '',
            firstname: '',
            nickname: '',
        };
        if (this._auth.isLoggedIn()) {
            this._router.navigate(['/']);
        }
        this._breadcrumbs.setTitle('Regisztráció');
    };
    RegistrationComponent.prototype.ngAfterViewInit = function () {
        this._emailField.nativeElement.focus();
    };
    RegistrationComponent.prototype.closeAlert = function (alert) {
        var index = this.msgs.indexOf(alert);
        this.msgs.splice(index, 1);
    };
    RegistrationComponent.prototype.doRegistration = function (regForm) {
        var _this = this;
        this.submitted = true;
        if (regForm.invalid) {
            this.msgs.push({
                severity: 'warning',
                summary: '',
                details: 'A becenév kivételével minden adatot kötelező megadni!'
            });
            return;
        }
        this.pending = true;
        this._auth.signUp(this.user).subscribe(function () { return _this._router.navigateByUrl(_this.next); }, this.onError.bind(this));
    };
    RegistrationComponent.prototype.onError = function (error) {
        this._messenger.handleError(error);
        this.pending = false;
        this.msgs[0] = {
            severity: 'danger',
            summary: 'Hiba!',
            details: this.getMessageFrom(error)
        };
        this._emailField.nativeElement.focus();
        this._emailField.nativeElement.select();
    };
    RegistrationComponent.prototype.getMessageFrom = function (error) {
        var message;
        if (error && error.json) {
            var eMessage = error.json();
            message = eMessage.message;
            if (eMessage.errors) {
                var messageParts = [];
                for (var key in eMessage.errors) {
                    if (eMessage.errors.hasOwnProperty(key)) {
                        messageParts.push(key + ': ' + eMessage.errors[key]);
                    }
                }
                message += ' Errors: ' + messageParts.join(', ');
            }
        }
        else {
            message = 'Ismeretlen hiba!';
        }
        return message;
    };
    return RegistrationComponent;
}());
export { RegistrationComponent };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/auth/registration/registration.component.ts.pre-build-optimizer.js